import React from "react";

import { IDownloadTypes } from "models/Order";
import IDevolutionInvoiceXmlDownloadButtonProps from "./interface";

import { notaFiscalAction } from 'components/ApplicationInsights/eventNames';
import DevolutionInvoiceDownloadButton from "../DevolutionInvoiceDownloadButton";  

const DevolutionInvoiceXmlDownloadButton: React.FC<IDevolutionInvoiceXmlDownloadButtonProps> = (props) => {
    const { order, className } = props;
    
    return (
        <DevolutionInvoiceDownloadButton
            textButton="Download XML de Devolução"
            trackName={notaFiscalAction.NOTA_DEVOLUCAO_XML}
            downloadType={IDownloadTypes.DEVOLUTION_INVOICE_XML}
            order={order}
            className={className}
        />
    );
};

export default DevolutionInvoiceXmlDownloadButton;